import { User } from "firebase/auth";
import Image from "next/image";
import React, { useState } from "react";
import ChevronDown from "./icons/ChevronDown";
import { NavUserDropdown } from "./NavUserDropdown";

type NavUserSectionProps = {
  user: User | null;
  handleLogout: () => void;
  handleLogin: () => void;
};

const NavUserSection = ({
  user,
  handleLogout,
  handleLogin,
}: NavUserSectionProps) => {
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);

  const handleOpenUserDropdown = () => {
    setIsUserDropdownOpen(!isUserDropdownOpen);
  };

  const handleDropdownLogout = () => {
    handleLogout();
    setIsUserDropdownOpen(false);
  };

  return (
    <>
      {user ? (
        <>
          <button
            onClick={handleOpenUserDropdown}
            aria-label="Open User Dropdown"
            className="flex items-center rounded-[100px] border-tab-border p-1 pr-2 hover:bg-tab-bg-hover active:bg-tab-bg-press medium:gap-1 medium:border"
          >
            <Image
              src={user.photoURL || ""}
              alt="google profile"
              width={32}
              height={32}
              className="rounded-[80px]"
            />
            <ChevronDown
              className={`hidden h-5 w-5 transition duration-200 medium:inline-block ${
                isUserDropdownOpen ? "rotate-180" : ""
              }`}
            />
          </button>
          {isUserDropdownOpen && (
            <NavUserDropdown user={user} handleLogout={handleDropdownLogout} />
          )}
        </>
      ) : (
        <button
          onClick={handleLogin}
          className="hidden h-[40px] shrink-0 items-center justify-center rounded-[100px] bg-BG-60 px-4 py-3.5 text-sm font-medium text-white hover:bg-BG-70 active:bg-BG-80 medium:inline-flex"
        >
          Sign in
        </button>
      )}
    </>
  );
};

export default NavUserSection;
